import React, { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Icon, IconName } from 'app/design-system/components/Icon';
import { ICON_NAME_ANDROID, ICON_NAME_APPLE } from 'app/design-system/constants/IconNames';
import { getModalLink } from 'app/widgets/DownloadModal';

import styles from './MobileAppIcons.module.scss';

type MobileAppIcon = {
  icon: IconName;
  dataGaEvent: string;
  link: string;
};

type MobileAppIconsProps = {
  className?: string;
};

export const MobileAppIcons: FC<MobileAppIconsProps> = ({ className }) => {
  const downloadModalLink = getModalLink('header');

  const items = useMemo<MobileAppIcon[]>(() => ([{
    icon: ICON_NAME_ANDROID,
    link: downloadModalLink,
    dataGaEvent: 'header-downloadApk',
  }, {
    icon: ICON_NAME_APPLE,
    link: downloadModalLink,
    dataGaEvent: 'header-downloadApk',
  }]), []);

  return (
    <ul className={classNames(styles.root, className)}>
      {items.map((item) => (
        <li key={item.icon}
            className={styles.item}>
          <Link to={item.link}
                className={styles.link}
                data-ga-event={item.dataGaEvent} >
            <Icon icon={item.icon} />
          </Link>
        </li>
      ))}
    </ul>
  );
};
